<form [formGroup]="formFields" (ngSubmit)="save()">
    
<div class="container">
    <div class="close-btn-fill-area" mat-dialog-close>
        <span class="close-btn">
        </span>
    </div>
    <p class="title">{{'TITLE_REPORT_FIELD' | translate}}</p>
    <div> 
<table>
        <tr>
            <td>
                <mat-label>{{'FORM_REPORT_DATE' | translate}}</mat-label>
            <mat-form-field  appearance="outline">
                <input matInput  type="date" formControlName="ReportDate" readonly="true">
            </mat-form-field>
            </td>
            <td>
                <mat-label>{{'FORM_REPORT_AFFECTED' | translate}}</mat-label>
            <mat-form-field appearance="outline">

                <input type="text" formControlName="affected" matInput readonly="true">
                
                
              </mat-form-field>
            
            </td>
        </tr>
        <tr>
            <td>
                <mat-label>{{'FORM_REPORT_BY' | translate}}</mat-label>
                <mat-form-field appearance="outline">
                    <input type="text" formControlName="reportedby" matInput readonly="true">            
                  </mat-form-field>
                
            </td>
            <td>
                <mat-label>{{'FORM_REPORT_FIELD' | translate}}</mat-label>
                <mat-form-field appearance="outline">

                    <input type="text" formControlName="fieldAgent" matInput>
                    
                    
                  </mat-form-field>
                
            </td>
        </tr>

        <tr>
            <td>
                <mat-label>{{'incidentStatus' | translate}}</mat-label>
                
                <mat-form-field appearance="outline" color="white" class="matformSelect">
                    
                    <mat-select formControlName="statusId">
                      
                      <mat-option *ngFor="let option of arrayReportStatus" [value]="option.id">{{option.name}}</mat-option>
                     
                    </mat-select>
                  </mat-form-field>
            </td>
            <td>
                <mat-label>{{'FORM_REPORT_AGENT' | translate}}</mat-label>
                <mat-form-field appearance="outline">

                    <input type="text" formControlName="agent" matInput>
                    
                    
                  </mat-form-field>
            </td>
        </tr>
        <tr>
            <td>
                <mat-label>{{'FORM_REPORT_SITE' | translate}}</mat-label>
                <mat-form-field appearance="outline">
                    <input type="text" formControlName="siteId" readonly="true" matInput>            
                  </mat-form-field>
              
            </td>
            <td>
                <mat-label>{{'FORM_REPORT_CLOSE' | translate}}</mat-label>
                
                <mat-form-field  appearance="outline">
                    <input matInput  type="date" readonly="true" formControlName="closingDate">
                </mat-form-field>
            </td>
        </tr>

        <tr>
            <td>
                <mat-label>{{'FORM_REPORT_REASON' | translate}}</mat-label>
                <mat-form-field appearance="outline">
                    <input type="text" formControlName="reasonId" readonly="true" matInput>            
                  </mat-form-field>
               
            </td>
            <td>
                <mat-label>{{'FORM_REPORT_CLOSE_BY' | translate}}</mat-label>
                
                <mat-form-field appearance="outline">
    
                    <input type="text" readonly="true" formControlName="reportedCloseby" matInput>
                    
                    
                  </mat-form-field>
            </td>
        </tr>
        <tr>
            <td>
                <mat-label>{{'FORM_REPORT_ADITIONAL' | translate}}</mat-label>
                
                <mat-form-field appearance="outline">
    
                    <input type="text" formControlName="aditional" readonly="true" matInput>
                    
                    
                  </mat-form-field>
            </td>
            <td>

            </td>
        </tr>
        <tr>
            <td>
                <button class="matbtnTransparent" mat-stroked-button (click)="close()">
                  
                    {{ 'DIALOG_BACK_CANCEL' | translate}}
                    
                </button>
            </td>
            <td>
                <button class="matbtn icon-button" mat-stroked-button>
                    
                    Save
                    
                </button>
            </td>
        </tr>
    </table> 

      
       
       
     
    </div>
</div>

</form>